<template>
  <div>
    <!-- Hero Section -->
    <section class="bg-gradient-to-br from-primary-800 to-primary-800 text-white section-padding">
      <div class="container-custom text-center">
        <h1 class="text-4xl md:text-5xl font-bold mb-6">
          Contact Us
        </h1>
        <p class="text-xl text-primary-100 max-w-3xl mx-auto">
          Ready to get started? We're here to help with all your home repair and maintenance needs. 
          Get in touch for a free estimate today.
        </p>
      </div>
    </section>

    <!-- Contact Information -->
    <section class="section-padding bg-[#f0f0f0]">
      <div class="container-custom">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <!-- Contact Form -->
          <div>
            <h2 class="text-3xl font-bold text-gray-900 mb-6">Get Your Free Estimate</h2>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScPMp6nExdSZm9OGbHLopNK-tBUst6zrkKOamyQ_G6eu_iklw/viewform?usp=dialog" width="100%" height="400" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
          </div>

          <!-- Contact Information -->
          <div class="space-y-8">
            <div>
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Get In Touch</h2>
              <p class="text-lg text-gray-600 mb-8">
                We're here to help with all your home repair and maintenance needs. 
                Contact us today for a free, no-obligation estimate.
              </p>
            </div>

            <!-- Contact Details -->
            <div class="space-y-6">
              <div class="flex items-start space-x-4">
                <div class="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <svg class="w-6 h-6 text-primary-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-lg font-semibold text-gray-900 mb-1">Phone</h3>
                  <p class="text-gray-600 mb-2">(561) 398-3356</p>
                </div>
              </div>

            </div>

            <!-- Business Hours -->
            <div class="bg-gray-50 rounded-xl p-6">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Business Hours</h3>
              <div class="space-y-2">
                <div class="flex justify-between">
                  <span class="text-gray-600">Monday - Friday</span>
                  <span class="font-medium">7:00 AM - 6:00 PM</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600">Saturday - Sunday</span>
                  <span class="font-medium">8:00 AM - 4:00 PM</span>
                </div>
              </div>
              <div class="mt-4 p-3 bg-primary-50 rounded-lg">
                <p class="text-sm text-primary-700">
                  <strong>Emergency Service:</strong> Available 24/7 for urgent repairs
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
    <!-- CTA Section -->
    <section class="section-padding bg-primary-800 text-white">
      <div class="container-custom text-center">
        <h2 class="text-3xl md:text-4xl font-bold mb-6">
          Ready to Get Started?
        </h2>
        <p class="text-xl mb-8 text-primary-100 max-w-2xl mx-auto">
          Contact us today for a free estimate and let us help you with all your home repair and maintenance needs.
        </p>
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:5613983356" class="btn-secondary bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary-600">
            Call Now: (561) 398-3356
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      isSubmitting: false,
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        service: '',
        description: '',
        agreement: false
      }
    }
  },
  methods: {
    submitForm() {
      this.isSubmitting = true
      
      // Simulate form submission
      setTimeout(() => {
        alert('Thank you for your inquiry! We will contact you within 24 hours.')
        this.resetForm()
        this.isSubmitting = false
      }, 2000)
    },
    resetForm() {
      this.form = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        service: '',
        description: '',
        agreement: false
      }
    }
  }
}
</script> 